import React from 'react'

import SidebarResource from './SidebarResource'
import SidebarEndpoint from './SidebarEndpoint'

import css from './Sidebar.module.scss'

// Map verbs to shorter names
const VERBS = {
  'get': 'GET',
  'options': 'OPTS',
  'post': 'POST',
  'put': 'PUT',
  'patch': 'PATCH',
  'delete': 'DEL',
}
const VERB_PRIORITY = Object.keys(VERBS)

const SidebarTag = ({ 
  tag,
  location
}) => (
  <li className={ css.tag }>
    <ul>
      <li>
        <h3>{ tag.name }</h3>
      </li>
      { tag.resources?.map(resource => (
        <li key={ resource.id }>
          <SidebarResource resource={resource} location={location} />
        </li>
      ))}
      { tag.endpoints.sort(prioritize).map(endpoint => (
        <li key={ endpoint.id }>
          <SidebarEndpoint endpoint={endpoint} location={location} />
        </li>
      ))}
    </ul>
  </li>
)

const prioritize = (a, b) => {
  return VERB_PRIORITY.indexOf(a.verb) - VERB_PRIORITY.indexOf(b.verb)
}

export default SidebarTag